import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": ""
}
const browserNotify = createSlice({
    name:'browserNotify',
    initialState,
    reducers:{
        addBrowserNotify: (_state, payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default browserNotify.reducer
export const addBrowserNotify = browserNotify.actions.addBrowserNotify